import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect-to-external-link-modal',
  templateUrl: './redirect-to-external-link-modal.component.html',
  styleUrls: ['./redirect-to-external-link-modal.component.scss'],
})
export class RedirectToExternalLinkModalComponent implements OnInit {
  @Input()
  payload: any;

  private alreadyRedirected: boolean = false;

  constructor() {}

  ngOnInit(): void {
    console.log(this.payload);
    setTimeout(() => {
      this.goToLink();
    }, 3000);
  }

  public onLinkClick() {
    this.alreadyRedirected = false;
    this.goToLink();
  }

  private goToLink() {
    if (this.alreadyRedirected) return;

    this.alreadyRedirected = true;
    window.open(this.payload.href, '_blank');
  }
}
